import React, { useState, useEffect } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarConfig from "../../../components/SidebarConfig";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";

//redux
import {
  getCountryUser,
  deleteCountryUser,
  editCountryUser,
  saveCountryUser,
} from "../../../redux/countryUser/actions";

const CountryMaintenance = (props) => {
  const schema = Yup.object().shape({
    nombre: Yup.string().ensure().required("**Campo requerido"),
    codigo: Yup.number().required("**Campo requerido"),
  });

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);

  //
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const [nombre, setNombre] = useState("");
  const [codigo, setCodigo] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "pais",
    desc: "País",
  });

  //
  const dispatch = useDispatch();
  const {
    loaderCountryUser,
    countryUser,
    countryUserFail,
    saveLoaderCountryUser,
    countryUserFormError,
  } = useSelector((store) => store.countryUser);

  const pages = Math.ceil(countryUser ? countryUser.count / limit : 0);

  //   Datos de CustomTable
  const columns = [
    {
      Header: "Código",
      accessor: "codigo",
    },
    {
      Header: "País",
      accessor: "nombre",
    },

    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="d-flex button-group " role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];
  const filters = [
    { id: "nombre", desc: "País" },
    { id: "codigo", desc: "Código" },
  ];

  const _getCountryUser = (
    offs = offset,
    lim = limit,
    code = codigo,
    npais = nombre,
    tipo_Busqueda = tipoBusqueda
  ) =>
    dispatch(
      getCountryUser({
        offset: offs,
        limit: lim,
        codigo: code,
        nombre: npais,

        tipo_busqueda: tipo_Busqueda,

        //   filter:

        //     tipoBusqueda.id === "fecha_creacion"
        //       ? filt !== ""
        //         ? !isNaN(filt)
        //           ? filt
        //           : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
        //               8
        //             )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
        //               4
        //             )}-${filt.charAt(0)}${filt.charAt(1)}`
        //         : filt
        //       : filt,
      })
    );

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteCountryUser(id, data));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCountryUser(oOffset, limit, oSearch);
  };

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCountryUser(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    if (!edit) {
      dispatch(saveCountryUser(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      dispatch(editCountryUser(req, index, setShowFormModal));
    }
  };
  useEffect(() => {
    _getCountryUser();
    dispatch(getCountryUser());
  }, []);
  return (
    <>
      <CustomNavbar onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">Paises</h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          <div className="px-2">
            
          </div>
          <div className="d-flex justify-content-around"></div>
          {!!countryUserFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {countryUserFail}
            </Alert>
          )}
          {!!countryUserFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {countryUserFail}
            </Alert>
          )}
          {loaderCountryUser ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : countryUser && countryUser.count > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={countryUser.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={countryUser.count}
                pages={pages}
                pagFunc={_getCountryUser}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay paises, comience creando algunos.
            </Alert>
          )}
        </Container>
        {/*Modal*/}
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              codigo: edit ? editItem.codigo : "",
              nombre: edit ? editItem.nombre : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              //setFieldValue,
              values,
              touched,
              //isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit ? "Editar País" : "Crear País"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {countryUserFormError &&
                  typeof countryUserFormError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {countryUserFormError}
                    </Alert>
                  ) : null}
                  <Form.Group as={Col} className="mb-1  ">
                    <Form.Label column sm="12" md="12">
                      Código
                    </Form.Label>

                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loaderCountryUser ? "12" : "12"}>
                        <Form.Control
                          name="codigo"
                          className="rounded-pill"
                          required
                          type="number"
                          value={values.codigo}
                          onBlur={handleBlur("codigo")}
                          onChange={(e) => handleChange(e)}
                          isInvalid={touched.codigo && !!errors.codigo}
                        ></Form.Control>
                      </Col>
                      {loaderCountryUser ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                    {touched.codigo && errors.codigo && (
                      <Col>
                        <small className="text-danger">{errors.codigo}</small>
                      </Col>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      País
                    </Form.Label>
                    <Form.Control
                      name="nombre"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre}
                      placeholder="País"
                      onBlur={handleBlur("nombre")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.nombre && !!errors.nombre}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre}
                    </Form.Control.Feedback>
                    {countryUserFormError &&
                    typeof countryUserFormError === "object" &&
                    countryUserFormError.nombre ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {countryUserFormError.nombre.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoaderCountryUser}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderCountryUser && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default CountryMaintenance;
